module.exports = __webpack_public_path__ + "media/images/icons/material/eye-closed-6259400ed5bd3f7b7ccddf2d7f963bc9.svg";